<template>
  <div class="loadingForAuthentication">
    <span></span>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'LoadingForAuthentication'
})
export default class LoadingForAuthentication extends Vue {}
</script>

<style lang="scss" scoped>
.loadingForAuthentication {
  position: absolute;
  top: 11px;
  left: 10px;
  height: 16px;
  width: 16px;
  background-color: $loadingBackground;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  span {
    display: block;
    background-color: $black;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: 50%;
    border: 2px solid $loadingBorder;
    border-top: 2px solid $colorPending;
    animation: spin 2s ease infinite;
  }
}
</style>
